import {getInfo, getOssToken} from "@/plugins/api";
import {EventBus} from "@/plugins/EUtils";
import OSS from "ali-oss";

const state = {
  ossToken:'',
  userInfo: {},
  identityName:'',
  identityId:'',
}

const mutations = {
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_IDENTITY_NAME:(state,identity_name)=>{
    state.identityName = identity_name
  },
  SET_IDENTITY_ID:(state,identity_id)=>{
    state.identityId = identity_id
  },
  SET_OSS_TOKEN:(state,oss_token)=>{
    state.ossToken = oss_token
  }
}

const actions = {
  setUserInfo({ commit }, identityId) {
    var Authorization = EUtils.getCookie('Authorization')
    if(Authorization){
      getInfo({identity_id:identityId,center:'1'}).then(res=>{
        commit('SET_USER_INFO', res.data)
      })
    }else{
      window.location.replace('/login')
    }
  },
  getOssToken({commit}){
    getOssToken().then(res=>{
      let val = res.data;
      let data1 = EUtils.decode(val);
      var data = JSON.parse(data1)
      var respon = EUtils.decrypted(data.value, data.iv)
      respon = JSON.parse(respon)
      const client = new OSS({
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
        region: "oss-cn-hangzhou",
        authorizationV4: true,
        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeyId: respon.AccessKeyId,
        accessKeySecret: respon.AccessKeySecret,
        // 从STS服务获取的安全令牌（SecurityToken）。
        stsToken: respon.SecurityToken,
        // 填写Bucket名称。
        bucket: 'skhd',
      });
      commit('SET_OSS_TOKEN', client)
    })
  },
  setIdentityName({ commit },identityName){
    EUtils.setCookie('identityName', encodeURIComponent(identityName),60*60*60*24*30*30)
    commit('SET_IDENTITY_NAME', identityName)
  },
  setIdentityId({commit},identityId){
    commit('SET_IDENTITY_ID', identityId)
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
